import React, { useEffect, useState } from "react";
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Row,
  Col,
  Container,
  Card,
} from "reactstrap";
import classnames from "classnames";
import HeaderCreateItem from "components/Common/HeaderReport";

import ChartDashboard from "components/Common/ChartDashboard";
import { addColorChart } from "helpers/erp_helper";
import httpService from "services/httpService";
import Table from "components/form-control/Table";
import { formatNumber } from "helpers/erp_helper";
import { useForm } from "react-hook-form";
import Spacer from "components/Common/Spacing";
import { CommonText } from "components/Common/TextCommon";
import { CommonButton } from "components/Common/ButtonCommon";
import moment from "moment";
import axios from "axios";
import * as XLSX from "xlsx";
import vi from "moment/locale/vi";

const tabs = {
  1: {
    name: "doanh thu chi nhánh",
    model: "Branch",
    titleChart: "Tổng doanh thu chi nhánh",
  },
  2: {
    name: "khách hàng",
    model: "Customer",
    titleChart: " Báo cáo thống kê nguồn khách hàng qua các nền tảng",
  },
  3: {
    name: "nhân viên",
    model: "TestAgent",
    titleChart: "Xếp hạng thành tích",
  },
  4: {
    name: "nạp tiền",
    model: "TestAgent",
    titleChart: "Tổng số tiền đã nạp",
  },
  5: {
    name: "rút tiền",
    model: "TestAgent",
    titleChart: "Tổng số tiền đã rút",
  },
};

const branchTable = [
  {
    text: "Chi Nhánh",
    field: "objectId",
    textAlign: "right",
    formatter: cell => <span style={{ fontWeight: "400" }}>{cell}</span>,
  },
  {
    text: "Doanh Số",
    field: "total",
    textAlign: "right",
    formatter: cell => (
      <span style={{ fontWeight: "400" }}>{formatNumber(cell)}</span>
    ),
  },
];

const customerTable = [
  {
    text: "Nền Tảng",
    field: "platform",
    textAlign: "right",
    formatter: cell => <span style={{ fontWeight: "400" }}>{cell}</span>,
  },
  {
    text: "Tổng Số Lượng",
    field: "totalCount",
    textAlign: "right",
    formatter: cell => (
      <span style={{ fontWeight: "400" }}>{formatNumber(cell)}</span>
    ),
  },
  {
    text: "Số Lượng Mới",
    field: "newCount",
    textAlign: "right",
    formatter: cell => (
      <span style={{ fontWeight: "400" }}>{formatNumber(cell)}</span>
    ),
  },
];

const employeeTable = [
  {
    text: "Tên Nhân Viên",
    field: "saleName",
    textAlign: "right",
    formatter: cell => <span style={{ fontWeight: "400" }}>{cell}</span>,
  },
  {
    text: "Doanh Số",
    field: "total",
    textAlign: "right",
    formatter: cell => (
      <span style={{ fontWeight: "400" }}>{formatNumber(cell)}</span>
    ),
  },
];

const withdrawTable = [
  {
    text: "Tổng số lượng GD",
    field: "totalTransaction",
    textAlign: "right",
    formatter: cell => (
      <span style={{ fontWeight: "400" }}>{formatNumber(cell)}</span>
    ),
  },
  {
    text: "Tổng số tiền GD",
    field: "totalPriceTransaction",
    textAlign: "right",
    formatter: cell => (
      <span style={{ fontWeight: "400" }}>{formatNumber(cell)}</span>
    ),
  },
];

const ReportPages = () => {
  const [currentActiveTab, setCurrentActiveTab] = useState("1");
  const [branchSummary, setBranchSummary] = useState([]);
  const [customerSummary, setCustomerSummary] = useState([]);
  const [employeeSummary, setEmployeeSummary] = useState([]);
  const [rechargeWithDrawSummary, setRechargeWithDrawSummary] = useState([]);
  const [dateFrom, setDateFrom] = useState(moment().format("YYYY-MM-DD"));
  const [dateTo, setDateTo] = useState(moment().format("YYYY-MM-DD"));
  const branchFormProps = useForm({
    mode: "onBlur",
  });

  const customerFormProps = useForm({
    mode: "onBlur",
  });

  const employeeFormProps = useForm({
    mode: "onBlur",
  });

  const rechargeWidthDrawFormProps = useForm({
    mode: "onBlur",
  });

  const toggle = tab => {
    if (currentActiveTab !== tab) setCurrentActiveTab(tab);
  };

  useEffect(() => {
    try {
      // bracnh
      getCustomerSumary();
      // employee
      getEmployeeSumary();
      // branch
      getBranchSumary();

      //recharge, widthdraw
      getRechargeWidthDrawSumary("deposit", false);
    } catch (e) {
      console.error(e);
    }
  }, []);

  useEffect(() => {
    if (currentActiveTab == 4) {
      getRechargeWidthDrawSumary("deposit");
      return;
    }

    if (currentActiveTab == 5) {
      getRechargeWidthDrawSumary("withdraw");
      return;
    }
  }, [currentActiveTab]);

  const getEmployeeSumary = async () => {
    const payload = {
      ...(dateFrom && { dateFrom }),
      ...(dateTo && { dateTo }),
    };
    try {
      const res = await httpService.post(
        "parse/functions/employee-summary",
        payload
      );
      if (res.result && res.result.statusCode === 201) {
        const resp = res.result.data;

        setEmployeeSummary(Object.values(resp));
        employeeFormProps.reset({ items: Object.values(resp) });
      }
    } catch (err) {
      console.error("error", err);
    }
  };

  const getCustomerSumary = async () => {
    const payload = {
      ...(dateFrom && { dateFrom }),
      ...(dateTo && { dateTo }),
    };
    try {
      const res = await httpService.post(
        "parse/functions/customer-summary",
        payload
      );
      if (res.result && res.result.statusCode === 201) {
        const resp = res.result.data;
        setCustomerSummary(resp);
        customerFormProps.reset({ items: resp });
      }
    } catch (err) {
      console.error("error", err);
    }
  };

  const getBranchSumary = async () => {
    const payload = {
      ...(dateFrom && { dateFrom }),
      ...(dateTo && { dateTo }),
    };
    try {
      const res = await httpService.post(
        "parse/functions/order-summary",
        payload
      );
      if (res.result && res.result.statusCode === 201) {
        const resp = res.result.data;
        const data = resp.map(item => {
          const newItem = { ...item };
          if (item.objectId === null) {
            newItem.objectId = "Online";
          }
          return newItem;
        });
        setBranchSummary(data);
        branchFormProps.reset({ items: data });
      }
    } catch (err) {
      console.error("error", err);
    }
  };

  const getRechargeWidthDrawSumary = async (type, isFilter) => {
    const token = localStorage.getItem("authUser");
    const optional = {
      headers: {
        "X-Parse-Application-Id": "SCWASRTWK1Y9AVMP1KFC",
        "X-Parse-Session-Token": JSON.parse(token),
      },
      params: {
        where: {
          type,
          status: "completed",
          ...(isFilter && {
            createdAt: {
              $gte: {
                __type: "Date",
                iso: moment(dateFrom).add(1, "days"),
              },
              $lte: {
                __type: "Date",
                iso: moment(dateTo).add(1, "days"),
              },
            },
          }),
        },
      },
    };

    try {
      const res = await axios.get(
        process.env.REACT_APP_BASE_URL + `parse/classes/Transaction`,
        optional
      );
      if (res.data.results) {
        const sumPrice = res.data.results.reduce((partialSum, item) => {
          return partialSum + Number(item.amount);
        }, 0);
        setRechargeWithDrawSummary({
          totalTransaction: res.data.results.length,
          totalPriceTransaction: Math.round(sumPrice),
        });
        rechargeWidthDrawFormProps.reset({
          items: [
            {
              totalTransaction: res.data.results.length,
              totalPriceTransaction: Math.round(sumPrice),
            },
          ],
        });
      }
    } catch (err) {
      console.error("error", err);
    }
  };

  const getDataChart = index => {
    let dataChart = {};

    if (index === 1) {
      const labels = branchSummary.map(item => {
        if (item.objectId === null) {
          return "Online";
        }

        return item.objectId;
      });

      const dataSets = labels.map(label => {
        return branchSummary.find(item => item.objectId === label).total;
      });

      dataChart["labels"] = labels;
      dataChart["datasets"] = [
        {
          label: "Chi Nhánh",
          data: dataSets,
          backgroundColor: addColorChart(dataSets),
        },
      ];
    }

    if (index === 2) {
      const labels = customerSummary.map(item => item.platform);
      const dataSets = labels.map(
        label => customerSummary.find(c => c.platform === label).totalCount
      );
      dataChart["labels"] = labels;
      dataChart["datasets"] = [
        {
          label: "Khách Hàng",
          data: dataSets,
          backgroundColor: addColorChart(dataSets),
        },
      ];
    }

    if (index === 3) {
      const labels = employeeSummary.map(employee => employee.saleName);
      const dataSets = labels.map(
        label => employeeSummary.find(e => e.saleName === label).total
      );
      dataChart["labels"] = labels;
      dataChart["datasets"] = [
        {
          label: "Nhân Viên",
          data: dataSets,
          backgroundColor: addColorChart(dataSets),
        },
      ];
    }
    if (index === 4) {
      let labels = [];

      labels.push(rechargeWithDrawSummary.totalPriceTransaction);

      dataChart["labels"] = [formatNumber(labels[0])];
      dataChart["datasets"] = [
        {
          label: "Tổng tiền",
          data: [...labels, 0],
          backgroundColor: addColorChart(labels),
        },
      ];
    }
    if (index === 5) {
      let labels = [];

      labels.push(rechargeWithDrawSummary.totalPriceTransaction);
      dataChart["labels"] = [formatNumber(labels[0] * -1)];
      dataChart["datasets"] = [
        {
          label: "Tổng tiền",
          data: [labels[0] * -1, 0],
          backgroundColor: addColorChart(labels),
        },
      ];
    }

    return dataChart;
  };

  const onClickFilter = () => {
    if (currentActiveTab == 1) {
      getBranchSumary();
    }

    if (currentActiveTab == 2) {
      getCustomerSumary();
    }

    if (currentActiveTab == 3) {
      getEmployeeSumary();
    }

    if (currentActiveTab == 4) {
      getRechargeWidthDrawSumary("deposit", true);
    }

    if (currentActiveTab == 5) {
      getRechargeWidthDrawSumary("withdraw", true);
    }
  };

  const handleOnExport = () => {
    const dataSheet = [];
    if (currentActiveTab == 1) {
      const dataCol = branchTable.map(item => {
        return item.text;
      });
      const dataField = branchSummary.map(item => {
        return [item.objectId || "", item.total];
      });
      dataSheet.push(dataCol, ...dataField);
      var wb = XLSX.utils.book_new();
      var ws = XLSX.utils.aoa_to_sheet(dataSheet);
      XLSX.utils.book_append_sheet(wb, ws, "sheet");
      XLSX.writeFile(wb, "doanhthu.xlsx");
      return;
    }

    if (currentActiveTab == 2) {
      const dataCol = customerTable.map(item => {
        return item.text;
      });
      const dataField = customerSummary.map(item => {
        return [item.platform, item.totalCount, item.newCount];
      });

      dataSheet.push(dataCol, ...dataField);
      var wb = XLSX.utils.book_new();
      var ws = XLSX.utils.aoa_to_sheet(dataSheet);
      XLSX.utils.book_append_sheet(wb, ws, "sheet");
      XLSX.writeFile(wb, "khachhang.xlsx");
      return;
    }

    if (currentActiveTab == 3) {
      const dataCol = employeeTable.map(item => {
        return item.text;
      });
      const dataField = employeeSummary.map(item => {
        return [item.saleName, item.total];
      });

      dataSheet.push(dataCol, ...dataField);
      var wb = XLSX.utils.book_new();
      var ws = XLSX.utils.aoa_to_sheet(dataSheet);
      XLSX.utils.book_append_sheet(wb, ws, "sheet");
      XLSX.writeFile(wb, "nhanvien.xlsx");
      return;
    }

    const dataCol = withdrawTable.map(item => {
      return item.text;
    });
    const dataField = rechargeWithDrawSummary?.map(item => {
      return [item.code, item.amount];
    });

    dataSheet.push(dataCol, ...dataField);
    var wb = XLSX.utils.book_new();
    var ws = XLSX.utils.aoa_to_sheet(dataSheet);
    XLSX.utils.book_append_sheet(wb, ws, "sheet");
    XLSX.writeFile(wb, "MyExcel.xlsx");
    return;
  };

  return (
    <div className="page-content">
      <Container fluid style={{ position: "relative" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            position: "absolute",
            right: 90,
            zIndex: 999,
          }}
        >
          <CommonButton onClick={handleOnExport}>
            <i className="bx bx-export"></i>
          </CommonButton>
        </div>
        <HeaderCreateItem title={"Báo cáo  " + tabs[currentActiveTab].name} />
        <Spacer size={10} />
        <Nav tabs className="d-flex justify-content-between">
          <div className="d-flex">
            <NavItem>
              <NavLink
                className={classnames({
                  active: currentActiveTab === "1",
                })}
                onClick={() => {
                  toggle("1");
                }}
              >
                Doanh Thu CN
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({
                  active: currentActiveTab === "2",
                })}
                onClick={() => {
                  toggle("2");
                }}
              >
                Khách hàng
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({
                  active: currentActiveTab === "3",
                })}
                onClick={() => {
                  toggle("3");
                }}
              >
                Nhân viên
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({
                  active: currentActiveTab === "4",
                })}
                onClick={() => {
                  toggle("4");
                }}
              >
                Nạp tiền
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({
                  active: currentActiveTab === "5",
                })}
                onClick={() => {
                  toggle("5");
                }}
              >
                Rút tiền
              </NavLink>
            </NavItem>
          </div>
          <div className="d-flex align-items-center">
            <div style={{ marginRight: "20px" }}>
              <CommonText level={7} mt={0} color={"#495057"}>
                Ngày bắt đầu
              </CommonText>
              <input
                type="date"
                style={{
                  marginLeft: "10px",
                  border: "1px solid #ced4da",
                  borderRadius: "5px",
                  padding: "5px 10px",
                  color: "#495057",
                }}
                value={dateFrom}
                onChange={e => setDateFrom(e.target.value)}
              />
            </div>
            <div style={{ marginRight: "20px" }}>
              <CommonText level={7} mt={0} color={"#495057"}>
                Ngày kết thúc
              </CommonText>
              <input
                type="date"
                style={{
                  marginLeft: "10px",
                  border: "1px solid #ced4da",
                  borderRadius: "5px",
                  padding: "5px 10px",
                  color: "#495057",
                }}
                value={dateTo}
                onChange={e => setDateTo(e.target.value)}
              />
            </div>
            <div style={{ marginRight: "18px" }}>
              <CommonButton level={0} onClick={() => onClickFilter()}>
                Lọc
              </CommonButton>
            </div>
          </div>
        </Nav>
        <TabContent activeTab={currentActiveTab}>
          {Object.keys(tabs).map((item, index) => {
            const selectedItem = tabs[currentActiveTab];
            const selectedHearder =
              index === 0
                ? branchTable
                : index === 1
                ? customerTable
                : index === 2
                ? employeeTable
                : withdrawTable;

            const selectedFormProps =
              index === 0
                ? branchFormProps
                : index === 1
                ? customerFormProps
                : index === 2
                ? employeeFormProps
                : rechargeWidthDrawFormProps;

            return (
              <TabPane tabId={`${index + 1}`} key={index}>
                <Row>
                  <Col lg={6} md={12}>
                    <Spacer size={20} />
                    <div style={{ backgroundColor: "#ffffff" }}>
                      <Table
                        disableAdd
                        disableDelete
                        headers={selectedHearder}
                        name="items"
                        formProps={{
                          errors: selectedFormProps.formState.errors,
                          ...selectedFormProps,
                        }}
                      />
                    </div>
                  </Col>
                  <Col lg={6} md={12}>
                    <Spacer size={10} />
                    <ChartDashboard
                      title={selectedItem.titleChart}
                      data={getDataChart(Number(item))}
                      typeDefault="bar"
                    />
                  </Col>
                </Row>
              </TabPane>
            );
          })}
        </TabContent>
      </Container>
    </div>
  );
};

export default ReportPages;
